(() => {
    document.querySelectorAll([
        '.headline-jumbo',
        '.headline-4',
        '.table thead',
        '.freeform-form-has-errors',
        '.link',
        '.button',
    ]).forEach((component) => {
        component.classList.add('font-supplementary--bold');
    });

    document.querySelectorAll([
        '.headline-1',
        '.headline-2',
        '.headline-3',
    ]).forEach((component) => {
        component.classList.add('font-supplementary--black');
    });
})();
